import React, { useCallback, useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Redirect } from 'react-router-dom';
import styled from 'styled-components';
import { userForgotPasswordAction, clearErrorAction } from 'store/actions/login';
import FormInput from 'components/common/Input';
import PortalButton from 'components/common/Button';
import { FONTS } from 'styles/theme/fonts';
import { COLORS } from 'styles/theme/colors';

export const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [emailSent, setEmailSent] = useState(false);
  const [goBack, setGoBack] = useState(false);
  const dispatch = useDispatch();

  const handleSubmit = useCallback(() => {
    dispatch(userForgotPasswordAction(email));
    setEmailSent(true);
  }, [dispatch, email]);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleBack = () => {
    dispatch(clearErrorAction());
    setGoBack(true);
  };

  useEffect(() => {
    const handleKeydown = (e) => {
      if (e.keyCode === 13 || e.key === 'enter') {
        handleSubmit();
      }
    };

    window.addEventListener('keydown', handleKeydown);
    return () => {
      window.removeEventListener('keydown', handleKeydown);
    };
  }, [email, handleSubmit]);

  return (
    <ForgotPassword.ForgotPwContainer>
      <ForgotPassword.ForgotPwHeader>
        <span>{emailSent ? 'WE SENT YOU AN EMAIL' : 'FORGOT PASSWORD'}</span>
        <ForgotPassword.StyledSubtext>
          {emailSent
            ? `Thanks for entering your email address. We’ve just sent you a password reset link. `
            : 'Enter the email address associated with your account and we will send you a password reset link.'}
        </ForgotPassword.StyledSubtext>
        {!emailSent && (
          <FormInput
            onChange={handleEmailChange}
            placeholder="Email"
            type="email"
            hasValue={email && email.length > 0}
          />
        )}
        {!emailSent && <PortalButton onSubmit={handleSubmit} text="CONTINUE" />}
        <PortalButton onSubmit={handleBack} isInverted={!emailSent} text="BACK" />
        {goBack && <Redirect to="/login" />}
      </ForgotPassword.ForgotPwHeader>
      <ForgotPassword.Alias>ALIAS BY GOAT GROUP</ForgotPassword.Alias>
    </ForgotPassword.ForgotPwContainer>
  );
};

ForgotPassword.ForgotPwContainer = styled.div`
  display: flex;
  justify-content: center;
  height: 394px;
  width: 290px;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  width: 100vw;
`;
ForgotPassword.ForgotPwHeader = styled.h1`
  font-weight: 500;
  font-family: ${FONTS.default};
  width: 289px;
  font-size: 20px;
  line-height: 24px;
  color: ${COLORS.primaryText};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  span {
    text-transform: uppercase;
  }
`;

ForgotPassword.StyledSubtext = styled.p`
  color: ${COLORS.primaryText};
  font-size: 14px;
  line-height: 20px;
  margin-top: 8px;
  font-family: ${FONTS.default};
  justify-content: start;
  display: flex;
  font-weight: 200;
  opacity: 0.5;
  letter-spacing: 0.25px;
`;

ForgotPassword.Alias = styled.div`
  font-size: 12px;
  letter-spacing: 3px;
  color: ${COLORS.secondaryText};
  position: absolute;
  bottom: 33px;
`;

export default ForgotPassword;
